import { forwardRef, type SVGProps } from 'react';

export type MinimizeProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const Minimize = forwardRef<SVGSVGElement, MinimizeProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="currentColor" viewBox="0 0 32 32">
    <path d="M28 28H4" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
  </svg>
));
Minimize.displayName = 'Minimize';
